import React 		from 'react'
import classnames 	from 'classnames'
import { connect } 	from 'react-redux'
import renderHTML 	from 'react-render-html'
import {
	StaticQuery,
	graphql,
	Link
} from 'gatsby'
import {
	isFinite,
	get
} from 'lodash'

import {
	parseInternalLink
} from '../cta-button'
import LinkWrapper 			from '../link-wrapper'
import SectionSpacer 		from '../section-spacer'
import {
	TextBlock
} from '../text-block'

import breakpoints 	from '../../lib/constants/breakpoints.json'
import {
	formatLink
} from '../../lib/formatLink'

const FooterLinks = ({ links, className }) => {
	return links && links.length > 0 ? <ul className={ className }>
		{ links.map((_link, _i) => {
				const [link, isInternal] = parseInternalLink(_link)
				return <li
					key={ _i }>
					<LinkWrapper
						to={ link }
						external={ !isInternal }
						>
						{ _link.label }
					</LinkWrapper>
				</li>
			}) }
	</ul> : null
}

const Footer = (props) => {
	const {
		options
	} = props

	const columns = get(options, 'columns')
	const copyrightNote = get(options, 'footer_copyright_note')
	const secondaryLinks = get(options, 'secondary_links')

	return <footer
		className="bg--blue">
		<SectionSpacer
			space={ 0.5 } />
		<div className="cont">
			<div className="cols">
				<div className="col col--3-12">
					<Link to="/"
						className="footer-logo" />
				</div>
				{ columns && columns.length > 0 ? columns.map((_column, _i) => {
						return <div
							key={ _i }
							className="col col--3-24 footer-links"
							>
							{ _column.heading ? <div className="footer-links-heading">{ _column.heading }</div> : null }
							<FooterLinks
								links={ _column.links }
								/>
						</div>
					}) : null }
			</div>
			<SectionSpacer space={ 2 } />
			<div className="footer-secondary">
				{ copyrightNote ? <div className="footer-copyright">
						<TextBlock
							className="textBlock--w-noMax"
							type="small">
							<p>{ renderHTML(copyrightNote) }</p>
						</TextBlock>
					</div> : null }
				<FooterLinks
					className="footer-secondary-links"
					links={ secondaryLinks }
					/>
			</div>
		</div>
	</footer>
}

export default (props) => {
	return <StaticQuery
		query={ graphql`
			query {
				options: allWordpressAcfOptions {
					edges {
						node {
							options {
								footer_copyright_note
								columns {
									heading
									links {
										label
										link_option
										link_external
										link_internal
										link_email
									}
								}
								secondary_links {
									label
									link_option
									link_external
									link_internal
									link_email
								}
							}
						}
					}
				}
			}
		` }
		render={ (data) => { 
			return <Footer
				options={ get(data, 'options.edges.0.node.options') }
				{ ...props }
				/>
		} } />
}
			